// swiper.js
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

// Work gallery swiper (single image, no pagination)
const workSwiper = document.querySelector('.work-swiper');
if (workSwiper) {
  new Swiper(workSwiper, {
    modules: [Navigation, A11y],
    slidesPerView: 1.1,
    spaceBetween: 24,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
    a11y: {
      prevSlideMessage: 'Previous image',
      nextSlideMessage: 'Next image',
    },
    navigation: {
      nextEl: workSwiper.querySelector('.swiper-button-next'),
      prevEl: workSwiper.querySelector('.swiper-button-prev'),
    },
  });
}

// Book swiper (auto width, equal height slides)
const bookSwiper = document.querySelector('.book-swiper');
if (bookSwiper) {
  new Swiper(bookSwiper, {
    modules: [Navigation, A11y],
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: false,
    a11y: {
      prevSlideMessage: 'Previous image',
      nextSlideMessage: 'Next image',
    },
    navigation: {
      nextEl: bookSwiper.querySelector('.swiper-button-next'),
      prevEl: bookSwiper.querySelector('.swiper-button-prev'),
    },
  });
}

// Project images swiper (auto width, equal height slides)
const projectImagesSwiper = document.querySelector('.project-images-swiper');
if (projectImagesSwiper) {
  new Swiper(projectImagesSwiper, {
    modules: [Navigation, A11y],
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: false,
    a11y: {
      prevSlideMessage: 'Previous image',
      nextSlideMessage: 'Next image',
    },
    navigation: {
      nextEl: projectImagesSwiper.querySelector('.swiper-button-next'),
      prevEl: projectImagesSwiper.querySelector('.swiper-button-prev'),
    },
  });
}

// Hero swiper (autoplay, no navigation)
const heroSwiper = document.querySelector('.hero-swiper');
if (heroSwiper) {
  new Swiper(heroSwiper, {
    modules: [Autoplay, A11y],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    a11y: {
      prevSlideMessage: 'Previous image',
      nextSlideMessage: 'Next image',
    },
  });
}

// Default swipers (multi-slide)
const swiperElements = document.querySelectorAll(
  '.swiper:not(.work-swiper):not(.book-swiper):not(.hero-swiper):not(.project-images-swiper)'
);
if (swiperElements.length) {
  swiperElements.forEach((el) => {
    new Swiper(el, {
      modules: [Navigation, Pagination, A11y],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1280: {
          slidesPerView: 3,
        },
      },
    });
  });
}
